import GridConfigCondition from 'core/grid/domain/gridConfigCondition';
import GridConfigSort from 'core/grid/domain/gridConfigSort';
import GridConfigColumn from 'core/grid/domain/gridConfigColumn';
import {action, observable, ObservableMap, map, computed} from "mobx";
import {CONFIGLEVEL, ID} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {DomainAncestor, entityConfig, fieldInfo} from "core/common/domain/DomainAncestor";
import {LovItem, default as MdEntity} from "core/metamodel/mdEntity";
import {GridLocation, HasAccessToEntity} from "core/grid/domain/grid";



@entityConfig()
export default class GridConfig extends DomainAncestor  implements HasAccessToEntity {


  static newInstance(gridLocation: GridLocation) {

      let gridConfig = new GridConfig(gridLocation, {
        $new: true,
        configLevel: CONFIGLEVEL.USER,
        gridScrollSize: gridLocation.defaultScrollSize,
        gridPageSize: gridLocation.defaultPageSize,
        maxColumnWidth: gridLocation.defaultMaxColumnWidth,
        hardRowLimit: gridLocation.defaultHardRowLimit,
        refreshOnPage: gridLocation.defaultRefreshOnPage,
        refreshOnData: gridLocation.defaultRefreshOnData,
        gridName: ''
      });

      gridConfig.gridLocation = gridLocation.gridLocation;
      gridConfig.$gridLocationRef = gridLocation;
      gridConfig.entityName = gridLocation.entityName;

      return gridConfig;
  }

  @observable public columns: GridConfigColumn[];

  @observable public conditions: GridConfigCondition[];

  @observable public gridId: number;

  @observable public configLevel: LovItem<CONFIGLEVEL>;
  @observable public user: LovItem;
  @observable public tenant: LovItem;
  @observable public tenantGroup: LovItem;

  public entityName: string;

  public gridLocation: string;
  public $gridLocationRef: GridLocation;


  /**
   * vlastni nazev
   */
  @observable public gridName: string;

  @observable public sortColumns: GridConfigSort[];

  /**
   * pole sirek sloupcu, pouze pro tento gridConfig, bez dat
   */
  @observable public gridWidths: number[][];


  /**
   * priznak, ze grid config je defaultni
   */
  @observable public defaultGrid: boolean;

  /**
   * velikost okna pro virtualni skrolovani
   */
  @observable public gridScrollSize: number;

  /**
   * pocet radku nacitany ze serveru (velikost stranky)
   */
  @observable public gridPageSize: number;

  /**
   * maximalni sirka jednoho sloupce
   */
  @observable public maxColumnWidth: number;

  /**
   * never read more than hardRowLimit rows, can be null/undefined
   */
  @observable public hardRowLimit: number;

  /**
   * should be PAGE level (GridCompConnected) grids filled with data
   */
  @observable public refreshOnPage: boolean;

  /**
   * This grid refreshes itself on data change
   */
  @observable public refreshOnData: boolean;

 @observable public  gridRowCss: LovItem;

  @observable public $errorMap: ObservableMap<string>;

  @observable public specialConditions: LovItem[];

  @observable public sqlCommand: string;

  constructor (gridLocation: GridLocation, json) {
    super(json);
    this.$gridLocationRef = gridLocation;
    this.conditions = (this.conditions) ? this.conditions.map(jsonGcc => new GridConfigCondition(this, jsonGcc)) : [];
    this.columns = (this.columns) ? this.columns.map(jsonGcc => new GridConfigColumn(this, jsonGcc)) : [];
    this.sortColumns = (this.sortColumns) ? this.sortColumns.map(jsonGcc => new GridConfigSort(this, jsonGcc)): [];

    if (!this.specialConditions) this.specialConditions = [];
    if (!this.$errorMap) this.$errorMap = new ObservableMap<string>();
  }




  public getId(): ID {
    return this.gridId;
  }

  public setId(id: ID): void {
    this.gridId = <any>id;
  }


  public getEntityRef(): MdEntity {
    return this.$gridLocationRef.$entityRef;
  }

  @action clone(): GridConfig {
    let newGridConfig = new GridConfig(this.$gridLocationRef, null);
    Object.assign(newGridConfig, this);
    newGridConfig.columns = [];
    newGridConfig.conditions = [];
    newGridConfig.sortColumns = [];
    newGridConfig.$errorMap = new ObservableMap<string>();

    // copy columns
    for(let s of this.columns) {
      newGridConfig.columns.push(new GridConfigColumn(newGridConfig, s));
    }

    // copy conditions
    for(let c of this.conditions) {
      newGridConfig.conditions.push(c.clone());
    }

    // copy sortColumns
    for(let s of this.sortColumns) {
      newGridConfig.sortColumns.push(new GridConfigSort(newGridConfig, s));
    }

    return newGridConfig;
  }

  @computed get searchLabel() : string[] {
    return this.columns.filter(gcCol => gcCol.field && gcCol.field.searchTermType).map(gcCol =>  {
        let operatorLabel = mdEntityService.entityMap.get('FILTEROPERATOR').lovItems.find(v => v.value === gcCol.field.searchTermType).label;
        return gcCol.field.label + ": " + operatorLabel;
      });
  }

  public getSuperFilters(): GridConfigCondition[] {
    return this.conditions.filter(gcc => gcc.superFilter);
  }


}



// WEBPACK FOOTER //
// ./src/core/grid/domain/gridConfig.ts